import { useMemo } from "react";
import { AffiliationsEnum, AffiliationsType } from "../../../Enums/PersonEnums";
import InputTextArea from "../../staff/InputTextArea";
import { usePersonForm } from "./personForm/PersonFormContext";
import CheckBoxGroup from "../../staff/CheckBoxGroup";

const ADDITIONAL_AFFILIATION_SLOTS = 4;

const ProfessionalCareer = () => {
  const { form, setField, touchField } = usePersonForm();

  const additionalAffiliationValues = useMemo(
    () =>
      Array.from({ length: ADDITIONAL_AFFILIATION_SLOTS }, (_, i) => form.additionalAffiliations?.[i] ?? ""),
    [form.additionalAffiliations]
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 flex-col items-start gap-4  w-full">
      <InputTextArea
        title="Significant Accomplishments"
        value={form.significantAccomplishments ?? ""}
        onChange={e => setField("significantAccomplishments", e)}
        maxChars={2000}
        showCharacterCount
        minHeightClassName="min-h-[202px]"
      />
      <div className="flex flex-col gap-4">
        <CheckBoxGroup<AffiliationsType>
          title="Industry Organization Affiliation"
          contentClassName="grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6 gap-2 lg:gap-4"
          options={Object.values(AffiliationsEnum) as AffiliationsType[]}
          value={(form.industryOrganizationAffiliation ?? []) as AffiliationsType[]}
          onChange={(next) =>
            setField("industryOrganizationAffiliation", next as AffiliationsType[])
          }
          getOptionValue={(affiliation) => affiliation}
          getOptionLabel={(affiliation) => affiliation}
        />

        <label className="font-semibold text-gray-font">Additional Affiliations</label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {additionalAffiliationValues.map((value, index) => (
            <InputTextArea
              key={index}
              title=""
              value={value}
              maxChars={50}
              showCharacterCount
              onChange={(v) => {
                const next = [...additionalAffiliationValues];
                next[index] = v;
                setField("additionalAffiliations", next);
                touchField("additionalAffiliations");
              }}
              minHeightClassName="min-h-[20px]"
            />
          ))}
        </div>
      </div>
      <InputTextArea
        title="Articles"
        value={form.publications ?? ""}
        onChange={e => setField("publications", e)}
        onBlur={() => touchField("publications")}
        maxChars={2000}
        showCharacterCount
        minHeightClassName="min-h-[202px]"
      />
      <InputTextArea
        title="Additional Information"
        value={form.additionalInformation ?? ""}
        onChange={e => setField("additionalInformation", e)}
        onBlur={() => touchField("additionalInformation")}
        maxChars={2000}
        showCharacterCount
        minHeightClassName="min-h-[202px]"
      />
      <InputTextArea
        title="Seminar"
        value={form.seminarPresentation ?? ""}
        onChange={e => setField("seminarPresentation", e)}
        onBlur={() => touchField("seminarPresentation")}
        maxChars={2000}
        showCharacterCount
        minHeightClassName="min-h-[202px]"
      />
      <InputTextArea
        title="Past Employment Positions"
        value={form.pastEmploymentPositions ?? ""}
        onChange={e => setField("pastEmploymentPositions", e)}
        onBlur={() => touchField("pastEmploymentPositions")}
        maxChars={2000}
        showCharacterCount
        minHeightClassName="min-h-[202px]"
      />
    </div>
  );
};

export default ProfessionalCareer;